<form [formGroup]="tableFilterForm" class="table-filter-form">
  <div class="row g-3 align-items-end">
    @if (mode !== 'event') {
      <div class="col-12 col-md-6 col-lg-4">
        <app-generic-autocomplete
          label="Nome tavolo"
          placeholder="Es. Serata Legacy"
          [control]="tableFilterForm.controls.tableName"
          [searchFn]="searchTableNameOptions"
          [displayFn]="displayStringOption"
          [showAllOnEmpty]="true"
          [minSearchLength]="1"
          [debounceMs]="50"
        >
        </app-generic-autocomplete>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <app-generic-autocomplete
          label="Gioco"
          placeholder="Es. Terraforming Mars"
          [control]="tableFilterForm.controls.gameName"
          [searchFn]="searchGameNameOptions"
          [displayFn]="displayStringOption"
          [showAllOnEmpty]="true"
          [minSearchLength]="1"
          [debounceMs]="50"
        >
        </app-generic-autocomplete>
      </div>
    }

    <div class="col-12 col-md-6 col-lg-4">
      <app-generic-autocomplete
        [label]="mode === 'event' ? 'Nome evento' : 'Evento'"
        [placeholder]="mode === 'event' ? 'Es. Serata giochi' : 'Es. Serata inaugurale'"
        [control]="tableFilterForm.controls.eventName"
        [searchFn]="searchEventNameOptions"
        [displayFn]="displayStringOption"
        [showAllOnEmpty]="true"
        [minSearchLength]="1"
        [debounceMs]="50"
        [disabled]="eventNameOptions.length === 0"
      >
      </app-generic-autocomplete>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <app-generic-autocomplete
        label="Luogo"
        placeholder="Es. Milano"
        [control]="tableFilterForm.controls.location"
        [searchFn]="searchLocationOptions"
        [displayFn]="displayStringOption"
        [showAllOnEmpty]="true"
        [minSearchLength]="1"
        [debounceMs]="50"
      >
      </app-generic-autocomplete>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <app-generic-autocomplete
        label="Organizzazione"
        placeholder="Es. Ludica Milano"
        [control]="tableFilterForm.controls.organization"
        [searchFn]="searchOrganizationOptions"
        [displayFn]="displayStringOption"
        [showAllOnEmpty]="true"
        [minSearchLength]="1"
        [debounceMs]="50"
        [disabled]="organizationOptions.length === 0"
      >
      </app-generic-autocomplete>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <label class="form-label" [attr.for]="mode + '-max-distance'">Distanza massima</label>
      <select [id]="mode + '-max-distance'" class="form-select" formControlName="maxDistanceKm">
        <option [ngValue]="null">Qualsiasi distanza</option>
        @for (km of distanceKmOptions; track km) {
          <option [ngValue]="km">Entro {{ km }} km</option>
        }
      </select>
      @if (!hasUserPosition()) {
        <div class="form-text">Attiva la geolocalizzazione per filtrare per distanza.</div>
      }
    </div>

    <div class="col-12 d-flex flex-column flex-sm-row justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary d-inline-flex align-items-center justify-content-center" (click)="onFilterReset()">
        <i class="bi bi-arrow-counterclockwise me-1" aria-hidden="true"></i>Reset
      </button>
    </div>
  </div>
</form>
